<mat-toolbar class="nav-header">
  <mat-toolbar-row>
    <div class="nav-controls">
      <button mat-icon-button (click)="sidenav.toggle()" class="sidenav-toggle">
        <mat-icon>menu</mat-icon>
      </button>
      <div class="nav-brand">
        <a [routerLink]="['home']">
          <img src="./assets/images/turner-logo.svg">
        </a>
      </div>
      <span><a class="app-title" [routerLink]="['home']">Lean Roadmap</a></span>
    </div>
    <div class="user-actions">
      <!--<ng-container *ngIf="user?.isAdmin">-->
        <button mat-button class="header-link" [matMenuTriggerFor]="belowMenu">Administration</button>
        <mat-menu #belowMenu="matMenu" yPosition="below">
          <a [routerLink]="['admin/manage-admin-users']" mat-menu-item style="text-decoration: none;">Manage Admin Users</a>
          <a [routerLink]="['admin/manage-regions']" mat-menu-item style="text-decoration: none;">Manage Regions</a>
          <a [routerLink]="['admin/manage-profit-centers']" mat-menu-item style="text-decoration: none;">Manage Profit Centers</a>
          <a [routerLink]="['admin/manage-unconfigured-profit-centers']" mat-menu-item style="text-decoration: none;">Manage Unconfigured Profit Centers</a>
          <a [routerLink]="['admin/manage-targets']" mat-menu-item style="text-decoration: none;">Manage Targets</a>
          <a [routerLink]="['admin/view-logs']" mat-menu-item style="text-decoration: none;">View Logs</a>
        </mat-menu>
        <!--</ng-container>-->
      <app-search-button />
      <app-help-button />
      <app-avatar />
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<mat-sidenav-container>
  <mat-sidenav #sidenav>
    <mat-nav-list>
      <a mat-menu-item [routerLink]="['link1']" routerLinkActive="active">Link 1</a>
      <a mat-menu-item [routerLink]="['link2']" routerLinkActive="active">Link 2</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: #FDFDFD;">
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    <app-footer />
  </mat-sidenav-content>
</mat-sidenav-container>
